import styled from 'styled-components';

const MobileOnly = styled.div `
  @media screen and (min-width: ${({ breakpoint, theme }) => breakpoint !== null && breakpoint !== void 0 ? breakpoint : theme.breakpoints.lg}) {
    display: none;
  }
`;

export { MobileOnly as default };
//# sourceMappingURL=MobileOnly.mjs.map
